module.exports = __webpack_public_path__ + "img/banner-principal.9c694c44.png";